<template>
  <div id="pdfupload">
    <FilePond  
        allow-multiple="true" 
        :allowPaste="true"
        v-on:init="handleFilePondInit"
        v-on:updatefiles="handleFilePondUpdateFile"
    />
  </div>
</template>
<script>
import vueFilePond from 'vue-filepond';
import '../../../assets/css/filepond.min.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import '../../../assets/css/filepond-plugin-image-preview.min.css';

export default {
    name: 'pdfupload',
    components: {
        FilePond: vueFilePond(FilePondPluginImagePreview)
    },
    data() {
        return {
            myFiles:[],
        }
    },
    methods: {
        handleFilePondInit () {
            // FilePond instance methods are available on `this.$refs.pond`
        },
        onload (e, r) {
            console.log(r)
        },
        handleFilePondUpdateFile(files){
            this.myFiles = files.map(files => files.file);
            this.$emit('pdfFileHandler', this.myFiles);
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/views/Common/pdf-upload/pdfUpload.vue